export default "__VITE_ASSET__BTr4aqyH__"